import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ClientRemindersEndpoints as Endpoints,
  type AttachFilesRequest,
  type AttachFilesResponse,
  type DeleteClientRemindersRequest,
  type DeleteClientRemindersResponse,
  type DisableAllClientRemindersRequest,
  type DisableAllClientRemindersResponse,
  type GetClientRemindersRequest,
  type GetClientRemindersResponse,
  type GetFilesRequest,
  type GetFilesResponse,
  type RemoveFilesRequest,
  type RemoveFilesResponse,
  type SetClientRemindersRequest,
  type SetClientRemindersResponse,
} from '@app/api/ClientReminders/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';

export const clientRemindersApi = createApi({
  reducerPath: 'clientRemindersApi',
  baseQuery: createApiBaseQuery('/ClientReminders'),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.GetClientReminders]: query<
      GetClientRemindersResponse,
      GetClientRemindersRequest
    >({
      query: (params) => ({
        url: Endpoints.GetClientReminders,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.SetClientReminders]: mutation<
      SetClientRemindersResponse,
      SetClientRemindersRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.SetClientReminders,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.DeleteClientReminders]: mutation<
      DeleteClientRemindersResponse,
      DeleteClientRemindersRequest
    >({
      query: (params) => ({
        url: Endpoints.DeleteClientReminders,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.DisableAllClientReminders]: mutation<
      DisableAllClientRemindersResponse,
      DisableAllClientRemindersRequest
    >({
      query: (params) => ({
        url: Endpoints.DisableAllClientReminders,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.AttachFiles]: mutation<AttachFilesResponse, AttachFilesRequest>({
      query: ({ data, ...params }) => ({
        url: Endpoints.AttachFiles,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.RemoveFiles]: mutation<RemoveFilesResponse, RemoveFilesRequest>({
      query: ({ data, ...params }) => ({
        url: Endpoints.RemoveFiles,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.GetFiles]: mutation<GetFilesResponse, GetFilesRequest>({
      query: ({ data, ...params }) => ({
        url: Endpoints.GetFiles,
        method: Methods.POST,
        params,
        data,
      }),
    }),
  }),
});

export const {
  useGetClientRemindersQuery,
  useSetClientRemindersMutation,
  useDeleteClientRemindersMutation,
  useDisableAllClientRemindersMutation,
  useAttachFilesMutation,
  useRemoveFilesMutation,
  useGetFilesMutation,
} = clientRemindersApi;
